module.exports = __webpack_public_path__ + "static/startup-program-ed006da48dfa6f574e4747d50ade95f8.svg";